import tenant from '@/config/tenant'
import store from '@/store'
import tokenManager from '@/Utils/tokenManager'
import axios from 'axios'

const client = axios.create({
  baseURL: tenant.buildTenantUrl()
})

const getAccount = () => {
  const account = localStorage.getItem('vitale-account')

  if (account != null) {
    return JSON.parse(account).id
  }

  return null
}

const getCountry = () => {
  return localStorage.getItem('country-code') || 'bra'
}

client.interceptors.request.use((config) => {
  // Usa o tokenManager para obter o token com validação de expiração
  const token = tokenManager.getToken()
  const accountId = getAccount()

  // Se não houver token válido, redireciona para login
  // Mas permite rotas públicas ou de autenticação
  if (!token && !config.url.includes('/auth/')) {
    store.dispatch('Auth/logout')
    window.location = '/'
    return Promise.reject(new Error('Token inválido ou expirado'))
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  config.headers.account_id = accountId
  config.headers.country = getCountry()

  return config
})

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch('Auth/logout')

      window.location = '/'
    }
    return Promise.reject(error)
  }
)

export default client
